import { render, staticRenderFns } from "./ChildStarships.vue?vue&type=template&id=6d5299cb&"
import script from "./ChildStarships.vue?vue&type=script&lang=js&"
export * from "./ChildStarships.vue?vue&type=script&lang=js&"
import style0 from "./ChildStarships.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports